import Campaign from './components/Campaign.vue'
import Unsubscribe from './components/Unsubscribe.vue'

let pagesMenu = {
    path: '/campaign',
    name: 'Campaign',
    component: Campaign,
}
let unsubscribeMenu = {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: Unsubscribe,
}

const routes = [
    pagesMenu,
    unsubscribeMenu,
    { path: '*', redirect: '/' },
    { path: '/', beforeEnter() {location.href = 'https://oneclose.ca'}},
];
export default routes